module.exports = __webpack_public_path__ + "img/GAME_CARDRIVE2.5bba03c6.jpg";